import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared";
import { getAuth, signInWithEmailLink } from "firebase/auth";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

const SignUpVerify = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const [user, setUser] = useState(null);
  const { authenticateUser, loading: authLoading } = useAuth("verify-email");
  const navigate = useNavigate(); // Initialize navigate for navigation

  useEffect(() => {
    const auth = getAuth();
    const url = new URL(window.location.href); // Create a URL object from the current page URL
    const oobCode = url.searchParams.get("oobCode");
    const continueUrlParam = url.searchParams.get("continueUrl");
    const urlParams = new URLSearchParams(window.location.search);
    let email = urlParams.get("email");
    let token = null; // Declare token and refreshToken for later use

    if (continueUrlParam) {
      try {
        const decodedUrl = decodeURIComponent(continueUrlParam);
        const innerUrl = new URL(decodedUrl);
        const rawEmail = innerUrl.searchParams.get("email");
        if (rawEmail) {
          email = decodeURIComponent(rawEmail);
        }
      } catch (e) {
        console.error("Error parsing continueUrl for email:", e);
      }
    }

    // Declare the async function inside useEffect
    const verifyEmail = async () => {
      if (email && oobCode) {
        // Check if the email link is valid
        try {
          const result = await signInWithEmailLink(auth, email, window.location.href);
          const signedInUser = result.user;
          //setUser(signedInUser); // ✅ Set in state so component re-renders

          token = await signedInUser.getIdToken();
          await authenticateUser(token);
        } catch (err) {
          console.error("Verification error:", err);
          setError(`Error during email verification: ${err.message}`);
          navigate("/auth/login"); // Navigate to the Login page
        } finally {
          setLoading(false); // Set loading to false after the process is done
        }
      }
      else {
        setError("Invalid or expired sign-in link.");
        setLoading(false);
      }
    };

    verifyEmail(); // Call the async function inside useEffect

  }, [navigate]); // Ensure dependencies are correctly set

  if (authLoading || loading) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  if (error) return <p>பிழை: {error}</p>;


  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | பதிவு சரிபார்ப்பு</title>
        <link rel="canonical" href="/auth/signup/verify" />
      </Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <div>
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
      </div >

      <Footer />
    </>
  );
};

export default SignUpVerify;
